import React, { useEffect, useRef } from 'react';
import * as echarts from 'echarts';
import useRecoleccionProvinciaBarras from '../../../hooks/administrador/recoleccion/useRecoleccionProvinciaBarras';
import '../../../styles/administrador.css';

const RecoleccionNfuProvinciaBarras = ({ year, mes, token, idAdministrador, provinciaSeleccionada, ciudadSeleccionada }) => {
  const chartRef = useRef(null);
  const { data, loading, error } = useRecoleccionProvinciaBarras(
    year, 
    mes, 
    token, 
    idAdministrador, 
    provinciaSeleccionada, 
    ciudadSeleccionada
  );

  useEffect(() => {
    if (loading || error || !chartRef.current) return;
    
    if (!Array.isArray(data) || data.length === 0) {
      return;
    }

    const chartDom = chartRef.current;
    let myChart = echarts.getInstanceByDom(chartDom) || echarts.init(chartDom);
    if (myChart) myChart.dispose();
    myChart = echarts.init(chartDom);

    const sortedData = [...data].sort((a, b) => parseInt(b.total) - parseInt(a.total));

    const topProvincias = sortedData.slice(0, 9);
    const otrasProvincias = sortedData.slice(9);

    const otrosTotal = otrasProvincias.reduce((sum, item) => sum + parseInt(item.total || 0), 0);

    if (otrosTotal > 0) {
        topProvincias.push({
            descripcion: 'Otros',
            total: otrosTotal
        });
    }

    const totalGeneral = sortedData.reduce((sum, item) => sum + parseInt(item.total || 0), 0);

    const option = {
        title: {
            text: 'Recolección por provincia',
            left: 'center',
            subtext: `TOTAL RECOLECCIONES: ${totalGeneral.toLocaleString()}`,
            subtextStyle: {
                fontWeight: 'bold',
                fontSize: '12px'
            }
        },
        tooltip: {
            trigger: 'axis',
            confine: true,
            axisPointer: {
                type: 'shadow'
            },
            formatter: function(params) {
                return `${params[0].name}: <b>${params[0].value.toLocaleString()} Recolecciones</b>`;
            }
        },
        grid: {
            left: '3%',
            right: '4%',
            bottom: '10%',
            containLabel: true
        },
        yAxis: {
            type: 'category',
            data: topProvincias.map(item => item.descripcion),
            axisLabel: {
                rotate: 0,
                fontSize: 12,
                interval: 0,
                fontWeight: 'bold',
                formatter: function(value) {
                    return value.length > 11 ? value.substring(0, 10) + '...' : value;
                }
            }
        },
        xAxis: {
            type: 'value',
            name: 'Cantidad [U]',
            axisLabel: {
                formatter: function(value) {
                    if (value >= 1000000) return (value / 1000000).toFixed(1) + 'M';
                    if (value >= 1000) return (value / 1000).toFixed(0) + 'k';
                    return value;
                }
            },
            splitLine: {
                show: true,
                lineStyle: {
                    type: 'dashed'
                }
            }
        },
        series: [{
            name: 'Total Recolecciones',
            type: 'bar',
            data: topProvincias.map(item => parseInt(item.total)),
            barWidth: '50%',
            itemStyle: {
                color: function(params) {
                    const colorPalette = ['#d1dc5a', '#e0f7e0', '#6ac5cb', '#45444e', '#a3b85b', '#3a6b74'];
                    return colorPalette[params.dataIndex % colorPalette.length];
                },
                borderRadius: [3, 3, 0, 0]
            },
            emphasis: {
                itemStyle: {
                    shadowBlur: 10,
                    shadowOffsetX: 0,
                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
            }
        }]
    };

    myChart.setOption(option);
    
    const updateChart = () => {
      myChart.resize();
    };
    
    window.addEventListener('resize', updateChart);
    
    return () => {
      window.removeEventListener('resize', updateChart);
      if (myChart && !myChart.isDisposed()) {
        myChart.dispose();
      }
    };
  }, [data, loading, error]);

  if (loading) {
    return <div className="grafica loading">Cargando datos de provincias...</div>;
  }

  if (error) {
    return (
      <div className="grafica error">
        <p>Error al cargar datos de provincias</p>
        <small>Detalles: {error.message || "Error desconocido"}</small>
      </div>
    );
  }

  return <div className="grafica" ref={chartRef}></div>;
};

export default RecoleccionNfuProvinciaBarras;